module.exports = __webpack_public_path__ + "img/ko.ff701fea.svg";